<template>
    <div>
        <base-stueck
                name="Briefe"
                path-name="Briefe"
                title="Was ich dir noch sagen wollte...."
                subtitle="Szenischer Abend aus Briefen der Geschichte"
                :hasPlakat="true"
                :bilder-anzahl="6"
        >
            <template #beschreibung>
              Es gibt Abschiedsbriefe, Liebesbriefe, Leserbriefe, Erpresserbriefe und noch viel mehr. Laute und leise
              Briefe. Mit vielen oder wenigen Worten. Briefe voller Fragen, Briefe voller Antworten. Persönliche
              Empfindungen bei Sender und Empfänger.<br><br>
              Ein emotionaler Abend voll von ungesagten, dafür geschriebenen Worten. Anais Nin, Marilyn Monroe, John
              Steinbeck oder auch Jack the Ripper sind nur einige der Personen, die an diesem Abend nochmals zu Wort kommen.
              Alles sind persönliche Botschaften, doch einige stehen exemplarisch für ihre Zeit und werfen ein Schlaglicht
              auf die damalige Gesellschaft.<br><br>
              Erleben Sie eine Reise durch Geschichte und Geschichten. Auf Sie warten kleine
              Geheimnisse, große Geständnisse, liebevolle Ermahnungen, traurige Gewissheiten und völlig Unerwartetes.
            </template>
        </base-stueck>
    </div>
</template>

<script>

    import BaseStueck from "../../components/waswar/BaseStueck";

    export default {
        name: "Briefe",
        components: {BaseStueck},
        metaInfo: {
            title: "Was ich dir noch sagen wollte....",
            meta: [
                {name: 'description', content: 'Details zu unserer Produktion: Was ich schon immer sagen wollte...'}
            ]
        },
    }
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  font-size: small;
  padding: 8px;
}

tr:first-child {
  background-color: #eee;
}
</style>